export const dietaryOptions = [
  {
    label: "Weight Goal",
    key: "weightGoal",
    type: "select",
    options: ["Weight Loss", "Weight Stabilization", "Weight Gain"],
  },
  {
    label: "Conditional Goal",
    key: "conditionGoal",
    type: "select",
    options: ["Improve Condition", "Maintain Condition", "Not Applicable"],
  },
  {
    label: "Gain Muscle",
    key: "gainMuscle",
    type: "select",
    options: ["Yes", "Not Important"],
  },
  {
    label: "Dietary Preferences",
    key: "dietaryPreferences",
    type: "multi-select",
    options: [
      "General",
      // "Standard",
      "Low-Calorie",
      "Bread Products",
      "Dairy Products",
      "Paleo",
      "Gluten-Free",
      "Intermittent Fasting",
      "Lactose-Free",
      "Diabetes-Friendly",
      "High-Fibre",
      "Low-Sodium",
      "Vegetarian",
      "Vegan",
      "Low-Carb",
      "Mediterranean",
      "Halal",
      "Kosher",
      "Flexitarian",
      "Carnivore",
      "Ketogenic",
      "High-Protein",
      "Low-Fat",
    ],
  },
  {
    label: "Select Multi Cuisine",
    key: "multiCusine",
    type: "multi-select",
    options: [
      "African",
      "American (Southern / Soul Food)",
      "American (Traditional)",
      "Arabian / Middle Eastern",
      "Asian Fusion",
      "Balkan",
      "British / English",
      "Caribbean",
      "Central European",
      "Chinese (Cantonese/Sichuan etc.)",
      "Comfort Food (International)",
      "Dutch",
      "Eastern European",
      "Filipino",
      "French",
      "German",
      "Greek",
      "Indian (North)",
      "Indian (South)",
      "Indonesian",
      "Iranian / Persian",
      "Irish",
      "Israeli",
      "Italian",
      "Japanese",
      "Jewish",
      "Korean",
      "Latin American",
      "Lebanese",
      "Light & Balanced (International)",
      "Malaysian",
      "Mediterranean",
      "Mexican",
      "Moroccan",
      "Nordic / Scandinavian",
      "Pakistani",
      "Polish",
      "Portuguese",
      "Russian",
      "South African",
      "Southeast Asian (general)",
      "Spanish",
      "Surinamese",
      "Swiss",
      "Thai",
      "Turkish",
      "Vegan Global",
      "Vegetarian European",
      "Vietnamese",
      "West African",
      "Western European",
    ],
  },
  

  {
    label: "Exclude this exotic dishes",
    key: "exoticDishes",
    type: "multi-select",
    options: [
      "None",
      "Insects",
      "Raw Seafood",
      "Offal",
      "Fermented Fish",
      "Frog Legs",
      "Century Eggs",
      "Blood-based-Dishes",
      "Animal Brains",
      "Balut (fertilized duck egg)",
      "Exotic Game Meats",
    ],
  },
  {
    label: "Food Budget",
    key: "foodBudget",
    type: "select",
    options: ["High", "Average", "Low"],
  },
  // {
  //   label: "Cooking Frequency",
  //   key: "cookingFrequency",
  //   type: "select",
  //   options: ["Daily", "Several Times Weekly", "Rarely", "Never"],
  // },
  {
    label: "Preparation Time",
    key: "preparationTime",
    type: "select",
    options: [
      // "Super Fast (up to 10 minutes)",
      "Quick and Easy (10 - 20 minutes)",
      "Moderate Cooking Time (20 - 35 minutes)",
      "Extended & Flavorful (35+ minutes)",
    ],
  },
];

export const tasteOptions = [
  {
    label: "Breakfast Taste Preferences",
    key: "breakfastTastePreferences",
    type: "multi-select",
    options: ["General", "Spicy", "Sweet", "Sour", "Mild"],
  },
  {
    label: "lunch Taste Preferences",
    key: "lunchTastePreferences",
    type: "multi-select",
    options: ["General", "Spicy", "Sweet", "Sour", "Mild"],
  },
  {
    label: "Dinner Taste Preferences",
    key: "dinnerTastePreferences",
    type: "multi-select",
    options: ["General", "Spicy", "Sweet", "Sour", "Mild"],
  },
  {
    label: "Afternoon Snacks",
    key: "afternoonSnacks",
    type: "multi-select",
    options: ["General", "Spicy", "Sweet", "Sour", "Mild"],
  },
  {
    label: "Evening Snacks",
    key: "eveningSnacks",
    type: "multi-select",
    options: ["General", "Spicy", "Sweet", "Sour", "Mild"],
  },
];

export const physicalCharacterstics = [
  {
    label: "Your Age",
    key: "yourAge",
    type: "numeric",
    options: [],
  },
  {
    label: "Height (cm)",
    key: "height",
    type: "numeric",
    options: [],
  },
  {
    label: "Weight",
    key: "weight",
    type: "numeric",
    options: [],
  },
  {
    label: "Waist Circumference (cm)",
    key: "waistCircumference",
    type: "numeric",
    options: [],
  },
  {
    label: "Body Fat Percentage (%)",
    key: "bodyFatPercentage",
    type: "numeric",
    options: [],
  },
  {
    label: "Current Physical Condition Status",
    key: "currentPhysicalConditionStatus",
    type: "select",
    options: ["Poor", "Average", "Good", "Excellent"],
  },
  // {
  //   label: "Gym Membership",
  //   key: "gymMembership",
  //   type: "select",
  //   options: ["Yes", "No"],
  // },
  {
    label: "Activity",
    key: "activity",
    type: "select",
    options: [
      "Basal Metabolic Rate (BMR)",
      "Sedentary (little or no exercise)",
      "Light (exercise 1-3 times/week)",
      "Moderate (exercise 4-5 times/week)",
      "Active (daily exercise or intense exercise 3-4 times/week)",
      "Very Active (intense exercise 6-7 times/week)",
      "Extra Active (very intense exercise daily, or physical job)",
    ],
  },
];

export const lifestyleOptions = [
  {
    label: "Daily Activity",
    key: "dailyActivity",
    type: "select",
    options: [
      "Mainly Sitting",
      "Moderate Physically Work",
      "Intensive Physically Work",
    ],
  },
  {
    label: "Sleep Habits",
    key: "sleepHabits",
    type: "select",
    options: ["Good Sleeper", "Moderate Sleeper", "Poor Sleeper"],
  },
  {
    label: "Stress Level",
    key: "stressLevel",
    type: "select",
    options: ["No Stress", "Moderate Stress", "High Stress"],
  },
];

export const exerciseOptions = [
  // {
  //   label: "Exercise Goal",
  //   key: "exerciseGoal",
  //   type: "select",
  //   options: [
  //     "Lose weight",
  //     "Improve endurance",
  //     "Get toned",
  //     "Physiotherapy",
  //     "Increase mobility",
  //     "Build strength",
  //   ],
  // },
  {
    label: "Equipment Categories",
    key: "equipmentCategories",
    // type: "multi-select",
    // options: [
    //   "Kettlebell",
    //   "Dumbbell",
    //   "Med Ball",
    //   "Barbell",
    //   "Mat",
    //   "Elastic Band",
    //   "Sandbag",
    //   "TRX",
    //   "Bench",
    //   "Jump Rope",
    //   "Free Weight",
    //   "Stepper",
    //   "Ab Wheel",
    //   "Adjustable Bench",
    //   "Agility Ladder",
    //   "Bench Press",
    //   "BOSU Ball",
    //   "Cable Biceps Bar",
    //   "Cable Triceps Bar",
    //   "Chest Press",
    //   "Crunch Machine",
    //   "Cycling Bike",
    //   "Decline Bench",
    //   "Elliptical Machine",
    //   "EZ Curl Bar",
    //   "Foam Roller",
    //   "Hack Squat Machine",
    //   "Hammer Strength Machine",
    //   "Incline Bench",
    //   "Incline Bench Press",
    //   "Lat Pulldown",
    //   "Leg Adduction / Abduction Machine",
    //   "Leg Curl Machine",
    //   "Leg Extension Machine",
    //   "Leg Press",
    //   "Pec Deck Machine",
    //   "Plyo Box",
    //   "Power Tower",
    //   "Preacher Bench",
    //   "Pull-up Bar",
    //   "Punching Bag",
    //   "Push-up Stands",
    //   "Rowing Machine",
    //   "Sit-up Bench",
    //   "Smith Machine",
    //   "Squat Rack",
    //   "Stair Stepper",
    //   "Treadmill",
    //   "Triceps Bar",
    //   "Booty Band",
    //   "Flat Band",
    //   "Loop Band",
    //   "Stability Ball",
    //   "Tube Band",
    //   "Balance Pad",
    //   "Rope Cables",
    //   "Reverse Hyper Machine",
    //   "Olympic Plate",
    //   "Battling Ropes",
    //   "Hurdle",
    //   "Cones",
    //   "Handle Medicine Ball",
    //   "Cable machine",
    //   "Chest press machine",
    //   "Row machine",
    //   "Tricep press machine",
    //   "Bicep curl machine",
    //   "Lateral pulldown machine",
    //   "Abdominal machine",
    //   "Seated leg press machine",
    //   "Shoulder press machine",
    //   "Assisted chin dip machine",
    //   "Glute machine",
    //   "Pectoral fly/rear deltoid machine",
    //   "Hip adduction machine",
    //   "Upright bike",
    //   "Air bike",
    //   "Indoor rowing machine",
    //   "Slant Board",
    //   "Gliding discs",
    //   "Resistance band set",
    //   "Pilates bar",
    //   "Pilates ring",
    //   "Push-up board",
    //   "ViPR",
    //   "Bodyweight",
    //   "Yoga Brick",
    //   "Swiss Ball",
    //   "Chair",
    //   "T-Bar",
    //   "Power Bag",
    //   "Landmine",
    //   "Hex Bar",
    //   "Pilates Ring",
    //   "Pilates Ball",
    // ],
    type: "select",
    options: ["Free Weights", "Bodyweight", "Gym Equipment"],
  },
  {
    label: "Difficulties",
    key: "difficultiesLevel",
    type: "select",
    options: ["beginner", "intermediate", "advanced"],
  },

  {
    label: "Workouts Categories",
    key: "workoutsCategories",
    type: "multi-select",
    options: [
      "Endurance",
      "Strength",
      "Balance",
      "Mobility",
      "Cardio",
      "HIIT",
      "Pilates",
      "Physiotherapy",
      "Other",
      "Yoga",
      "Tabata",
      "Sport Mastery",
    ],
  },
  {
    label: "Selectable Days",
    key: "selectableDays",
    type: "multi-select",
    options: [
      "All Days",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ],
  },
  {
    label: "Daily Exercise Time Preference",
    key: "dailyExerciseTimePreference",
    type: "select",
    options: [
      "15 Minutes",
      "30 Minutes",
      "45 Minutes",
      "60 Minutes",
      "90 Minutes",
      "90+ Minutes",
    ],
  },
  // {
  //   label: "Exercise Location Preference",
  //   key: "exerciseLocationPreference",
  //   type: "multi-select",
  //   options: ["Home", "Outdoor", "Gym"],
  // },
];

export const medicalOptions = [
  {
    label: "Health Conditions",
    key: "healthConditions",
    type: "multi-select",
    options: [
      "None",
      "High Blood Pressure",
      "High Cholesterol",
      "Diabetes",
      "Thyroid Problems",
      "Cardiovascular Diseases",
      "Rheumatic Disorders",
      "Chronic Kidney Disease",
      "Gastrointestinal Issue",
      "Aesthma",
      "COPD",
    ],
  },
  {
    label: "Food Allergies",
    key: "foodAllergies",
    type: "multi-select",
    options: [
      "None",
      "Dairy",
      "Gluten",
      "Nuts",
      "Eggs",
      "Fish & Shellfish",
      "Peanuts",
      "Soy",
      "Fruit",
      "Sulfites/Preservatives",
      "Sesame Seeds",
    ],
  },
];

export const weightOptions = [
  {
    label: "Target Weight",
    key: "targetWeight",
    type: "numeric",
    options: [],
  },
  {
    label: "Goal Body Fat",
    key: "goalBodyFat",
    type: "numeric",
    options: [],
  },
  {
    label: "Goal Waist Circumference",
    key: "goalWaistCircumference",
    type: "numeric",
    options: [],
  },
  {
    label: "Maintenance Calories (Kcal)",
    key: "maintenanceCalories",
    type: "numeric",
    options: [],
  },
  {
    label: "Target Daily Calories (Kcal)",
    key: "targetDailyCalories",
    type: "numeric",
    options: [],
  },
    {
    label: "Target Active Time (Minutes)",
    key: "targetActiveTime",
    type: "numeric",
    options: [],
  },
    {
    label: "Target Burn Calories (kcal)",
    key: "detailTargetBurnCalories",
    type: "numeric",
    options: [],
  },
    {
    label: "Advised Steps",
    key: "goalSteps",
    type: "numeric",
    options: [],
  },
  {
    label: "Timeline",
    key: "timeline",
    type: "select",
    options: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ],
  },
  {
    label: "Week/Months",
    key: "durationType",
    type: "select",
    options: ["Week", "Month"],
  },
  {
    label: "Equipment Categories",
    key: "equipmentCategories",
    type: "select",
    options: ["Free Weights", "Bodyweight", "Gym Equipment"],
  },
  {
    label: "Difficulties",
    key: "difficultiesLevel",
    type: "select",
    options: ["beginner", "intermediate", "advanced"],
  },

  {
    label: "Workouts Categories",
    key: "workoutsCategories",
    type: "multi-select",
    options: [
      "Endurance",
      "Strength",
      "Balance",
      "Mobility",
      "Cardio",
      "HIIT",
      "Pilates",
      "Physiotherapy",
      "Other",
      "Yoga",
      "Tabata",
      "Sport Mastery",
    ],
  },
  {
    label: "Selectable Days",
    key: "selectableDays",
    type: "multi-select",
    options: [
      "All Days",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ],
  },
  {
    label: "Daily Exercise Time Preference",
    key: "dailyExerciseTimePreference",
    type: "select",
    options: [
      "15 Minutes",
      "30 Minutes",
      "45 Minutes",
      "60 Minutes",
      "90 Minutes",
      "90+ Minutes",
    ],
  },
];

export const MultiCountryCusineOptions = [
  {
    label: "Select Multi Cuisine",
    key: "multiCusine",
    type: "multi-select",
    options: [
      "African",
      "American (Southern / Soul Food)",
      "American (Traditional)",
      "Arabian / Middle Eastern",
      "Asian Fusion",
      "Balkan",
      "British / English",
      "Caribbean",
      "Central European",
      "Chinese (Cantonese/Sichuan etc.)",
      "Comfort Food (International)",
      "Dutch",
      "Eastern European",
      "Filipino",
      "French",
      "German",
      "Greek",
      "Indian (North)",
      "Indian (South)",
      "Indonesian",
      "Iranian / Persian",
      "Irish",
      "Israeli",
      "Italian",
      "Japanese",
      "Jewish",
      "Korean",
      "Latin American",
      "Lebanese",
      "Light & Balanced (International)",
      "Malaysian",
      "Mediterranean",
      "Mexican",
      "Moroccan",
      "Nordic / Scandinavian",
      "Pakistani",
      "Polish",
      "Portuguese",
      "Russian",
      "South African",
      "Southeast Asian (general)",
      "Spanish",
      "Surinamese",
      "Swiss",
      "Thai",
      "Turkish",
      "Vegan Global",
      "Vegetarian European",
      "Vietnamese",
      "West African",
      "Western European",
    ],
  },
];

export const initialPreferences = {
  gainMuscle: "",
  dietaryPreferences: [],
  foodBudget: "",
  preparationTime: "",
  // cookingFrequency: "",
  breakfastTastePreferences: [],
  lunchTastePreferences: [],
  dinnerTastePreferences: [],
  afternoonSnacks: [],
  eveningSnacks: [],
  yourAge: "",
  height: "",
  weight: "",
  weightUnit: "kg",
  targetWeightUnit: "kg",
  waistCircumference: "",
  bodyFatPercentage: "",
  currentPhysicalConditionStatus: "",
  // gymMembership: "",
  dailyActivity: "",
  sleepHabits: "",
  stressLevel: "",
  activity: "",
  selectableDays: [],
  dailyExerciseTimePreference: "",
  equipmentCategories:"",
  workoutsCategories:[],
  // exerciseLocationPreference: [],
  foodAllergies: ["None"],
  healthConditions: ["None"],
  targetWeight: "",
  timeline: "",
  durationType: "",
  multiCusine: [],
  exoticDishes: ["None"],
  weightGoal: "",
  conditionGoal: "",
  maintenanceCalories: "",
  targetDailyCalories: "",
  dailyCalorieAdjustment: "",
  goalSteps: "",
  detailTargetBurnCalories: "",
  targetActiveTime: ""
  // exerciseGoal: "",
};

export const AllPreferences = [
  {
    mod_label: "General Preferences",
    value: [
      {
        label: "Weight Goal",
        key: "weightGoal",
        type: "select",
        options: ["Weight Loss", "Weight Stabilization", "Weight Gain"],
      },
      {
        label: "Condition Goal",
        key: "conditionGoal",
        type: "select",
        options: ["Improve Condition", "Maintain Condition", "Not Applicable"],
      },
      {
        label: "Daily Activity",
        key: "dailyActivity",
        type: "select",
        options: [
          "Mainly Sitting",
          "Moderate Physically Work",
          "Intensive Physically Work",
        ],
      },
      // {
      //   label: "Preferred Coach",
      //   key: "preferredCoach",
      //   type: "select",
      //   options: ["Male", "Female"],
      // },
      // {
      //   label: "Language",
      //   key: "language",
      //   type: "select",
      //   options: ["English", "Nederlands"],
      // },
      {
        label: "Sleep Habits",
        key: "sleepHabits",
        type: "select",
        options: ["Good Sleeper", "Moderate Sleeper", "Poor Sleeper"],
      },
      {
        label: "Stress Level",
        key: "stressLevel",
        type: "select",
        options: ["No Stress", "Moderate Stress", "High Stress"],
      },
    ],
  },
  {
    mod_label: "Physical Characteristics",
    value: [
      {
        label: "Your Age",
        key: "yourAge",
        type: "numeric",
        options: [],
      },
      {
        label: "Height (cm)",
        key: "height",
        type: "numeric",
        options: [],
      },
      {
        label: "Weight",
        key: "weight",
        type: "numeric",
        options: [],
      },
      {
        label: "Waist Circumference (cm)",
        key: "waistCircumference",
        type: "numeric",
        options: [],
      },
      {
        label: "Activity",
        key: "activity",
        type: "select",
        options: [
          "Basal Metabolic Rate (BMR)",
          "Sedentary (little or no exercise)",
          "Light (exercise 1-3 times/week)",
          "Moderate (exercise 4-5 times/week)",
          "Active (daily exercise or intense exercise 3-4 times/week)",
          "Very Active (intense exercise 6-7 times/week)",
          "Extra Active (very intense exercise daily, or physical job)",
        ],
      },
      {
        label: "Body Fat Percentage (%)",
        key: "bodyFatPercentage",
        type: "numeric",
        options: [],
      },
      {
        label: "Current Physical Condition Status",
        key: "currentPhysicalConditionStatus",
        type: "select",
        options: ["Poor", "Average", "Good", "Excellent"],
      },
    ],
  },
  {
    mod_label: "Medical Background",
    value: [
      {
        label: "Health Conditions",
        key: "healthConditions",
        type: "multi-select",
        options: [
          "None",
          "High Blood Pressure",
          "High Cholesterol",
          "Diabetes",
          "Thyroid Problems",
          "Cardiovascular Diseases",
          "Rheumatic Disorders",
          "Chronic Kidney Disease",
          "Gastrointestinal Issue",
          "Aesthma",
          "COPD",
        ],
      },
      {
        label: "Food Allergies",
        key: "foodAllergies",
        type: "multi-select",
        options: [
          "None",
          "Dairy",
          "Gluten",
          "Nuts",
          "Eggs",
          "Fish & Shellfish",
          "Peanuts",
          "Soy",
          "Fruit",
          "Sulfites/Preservatives",
          "Sesame Seeds",
        ],
      },
    ],
  },
  {
    mod_label: "Dietary Preferences",
    value: [
      {
        label: "Diet Type",
        key: "dietaryPreferences",
        type: "multi-select",
        options: [
          "General",
          // "Standard",
          "Low-Calorie",
          "Bread Products",
          "Dairy Products",
          "Paleo",
          "Gluten-Free",
          "Intermittent Fasting",
          "Lactose-Free",
          "Diabetes-Friendly",
          "High-Fibre",
          "Low-Sodium",
          "Vegetarian",
          "Vegan",
          "Low-Carb",
          "Mediterranean",
          "Halal",
          "Kosher",
          "Flexitarian",
          "Carnivore",
          "Ketogenic",
          "High-Protein",
          "Low-Fat",
        ],
      },
      {
        label: "Food Budget",
        key: "foodBudget",
        type: "select",
        options: ["High", "Average", "Low"],
      },
      {
        label: "Preparation Time",
        key: "preparationTime",
        type: "select",
        options: [
          "Quick and Easy (10 - 20 minutes)",
          "Moderate Cooking Time (20 - 35 minutes)",
          "Extended & Flavorful (35+ minutes)",
        ],
      },
      {
        label: "Breakfast Taste Preferences",
        key: "breakfastTastePreferences",
        type: "multi-select",
        options: ["General", "Spicy", "Sweet", "Sour", "Mild"],
      },
      {
        label: "Lunch Taste Preferences",
        key: "lunchTastePreferences",
        type: "multi-select",
        options: ["General", "Spicy", "Sweet", "Sour", "Mild"],
      },
      {
        label: "Dinner Taste Preferences",
        key: "dinnerTastePreferences",
        type: "multi-select",
        options: ["General", "Spicy", "Sweet", "Sour", "Mild"],
      },
      {
        label: "Afternoon Snacks",
        key: "afternoonSnacks",
        type: "multi-select",
        options: ["General", "Spicy", "Sweet", "Sour", "Mild"],
      },
      {
        label: "Evening Snacks",
        key: "eveningSnacks",
        type: "multi-select",
        options: ["General", "Spicy", "Sweet", "Sour", "Mild"],
      },
      {
        label: "Regional Food Country",
        key: "selectedCountry",
        type: "country-select",
        options: [],
      },
      {
        label: "Multi Cuisine",
        key: "multiCusine",
        type: "multi-select",
        options: [
          "African",
          "American (Traditional)",
          "American (Southern / Soul Food)",
          "Arabian / Middle Eastern",
          "Asian Fusion",
          "Balkan",
          "British / English",
          "Caribbean",
          "Central European",
          "Chinese (Cantonese/Sichuan etc.)",
          "Dutch",
          "Eastern European",
          "Filipino",
          "French",
          "German",
          "Greek",
          "Indian (North)",
          "Indian (South)",
          "Indonesian",
          "Iranian / Persian",
          "Irish",
          "Israeli",
          "Italian",
          "Japanese",
          "Jewish",
          "Korean",
          "Latin American",
          "Lebanese",
          "Malaysian",
          "Mediterranean",
          "Mexican",
          "Moroccan",
          "Nordic / Scandinavian",
          "Polish",
          "Portuguese",
          "Russian",
          "South African",
          "Southeast Asian (general)",
          "Spanish",
          "Surinamese",
          "Swiss",
          "Thai",
          "Turkish",
          "Vietnamese",
          "West African",
          "Western European",
          "Vegetarian European",
          "Vegan Global",
          "Light & Balanced (International)",
          "Comfort Food (International)",
          "Pakistani",
        ],
      },
      {
        label: "Exclude this Exotic Dish",
        key: "exoticDishes",
        type: "multi-select",
        options: [
          "None",
          "Insects",
          "Raw Seafood",
          "Offal",
          "Fermented Fish",
          "Frog Legs",
          "Century Eggs",
          "Blood-based-Dishes",
          "Animal Brains",
          "Balut (fertilized duck egg)",
          "Exotic Game Meats",
        ],
      },
    ],
  },
  {
    mod_label: "Exercise Preferences",
    value: [
      {
        label: "Daily Exercise Time Preference",
        key: "dailyExerciseTimePreference",
        type: "select",
        options: [
          "15 Minutes",
          "30 Minutes",
          "45 Minutes",
          "60 Minutes",
          "90 Minutes",
          "90+ Minutes",
        ],
      },
      // {
      //   label: "Exercise Location Preference",
      //   key: "exerciseLocationPreference",
      //   type: "multi-select",
      //   options: ["Home", "Outdoor", "Gym"],
      // },
      {
        label: "Gain Muscle",
        key: "gainMuscle",
        type: "select",
        options: ["Yes", "Not Important"],
      },
      // {
      //   label: "Gym Membership",
      //   key: "gymMembership",
      //   type: "select",
      //   options: ["Yes", "No"],
      // },
      {
        label: "Selectable Days",
        key: "selectableDays",
        type: "multi-select",
        options: [
          "All Days",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
      },
      // {
      //   label: "Exercise Goal",
      //   key: "exerciseGoal",
      //   type: "select",
      //   options: [
      //     "Lose weight",
      //     "Improve endurance",
      //     "Get toned",
      //     "Physiotherapy",
      //     "Increase mobility",
      //     "Build strength",
      //   ],
      // },
      // {
      //   label: "Equipment Categories",
      //   key: "equipmentCategories",
      //   // type: "multi-select",
      //   // options: [
      //   //   "Kettlebell",
      //   //   "Dumbbell",
      //   //   "Med Ball",
      //   //   "Barbell",
      //   //   "Mat",
      //   //   "Elastic Band",
      //   //   "Sandbag",
      //   //   "TRX",
      //   //   "Bench",
      //   //   "Jump Rope",
      //   //   "Free Weight",
      //   //   "Stepper",
      //   //   "Ab Wheel",
      //   //   "Adjustable Bench",
      //   //   "Agility Ladder",
      //   //   "Bench Press",
      //   //   "BOSU Ball",
      //   //   "Cable Biceps Bar",
      //   //   "Cable Triceps Bar",
      //   //   "Chest Press",
      //   //   "Crunch Machine",
      //   //   "Cycling Bike",
      //   //   "Decline Bench",
      //   //   "Elliptical Machine",
      //   //   "EZ Curl Bar",
      //   //   "Foam Roller",
      //   //   "Hack Squat Machine",
      //   //   "Hammer Strength Machine",
      //   //   "Incline Bench",
      //   //   "Incline Bench Press",
      //   //   "Lat Pulldown",
      //   //   "Leg Adduction / Abduction Machine",
      //   //   "Leg Curl Machine",
      //   //   "Leg Extension Machine",
      //   //   "Leg Press",
      //   //   "Pec Deck Machine",
      //   //   "Plyo Box",
      //   //   "Power Tower",
      //   //   "Preacher Bench",
      //   //   "Pull-up Bar",
      //   //   "Punching Bag",
      //   //   "Push-up Stands",
      //   //   "Rowing Machine",
      //   //   "Sit-up Bench",
      //   //   "Smith Machine",
      //   //   "Squat Rack",
      //   //   "Stair Stepper",
      //   //   "Treadmill",
      //   //   "Triceps Bar",
      //   //   "Booty Band",
      //   //   "Flat Band",
      //   //   "Loop Band",
      //   //   "Stability Ball",
      //   //   "Tube Band",
      //   //   "Balance Pad",
      //   //   "Rope Cables",
      //   //   "Reverse Hyper Machine",
      //   //   "Olympic Plate",
      //   //   "Battling Ropes",
      //   //   "Hurdle",
      //   //   "Cones",
      //   //   "Handle Medicine Ball",
      //   //   "Cable machine",
      //   //   "Chest press machine",
      //   //   "Row machine",
      //   //   "Tricep press machine",
      //   //   "Bicep curl machine",
      //   //   "Lateral pulldown machine",
      //   //   "Abdominal machine",
      //   //   "Seated leg press machine",
      //   //   "Shoulder press machine",
      //   //   "Assisted chin dip machine",
      //   //   "Glute machine",
      //   //   "Pectoral fly/rear deltoid machine",
      //   //   "Hip adduction machine",
      //   //   "Upright bike",
      //   //   "Air bike",
      //   //   "Indoor rowing machine",
      //   //   "Slant Board",
      //   //   "Gliding discs",
      //   //   "Resistance band set",
      //   //   "Pilates bar",
      //   //   "Pilates ring",
      //   //   "Push-up board",
      //   //   "ViPR",
      //   //   "Bodyweight",
      //   //   "Yoga Brick",
      //   //   "Swiss Ball",
      //   //   "Chair",
      //   //   "T-Bar",
      //   //   "Power Bag",
      //   //   "Landmine",
      //   //   "Hex Bar",
      //   //   "Pilates Ring",
      //   //   "Pilates Ball",
      //   // ],
      //   type: "select",
      //   options: ["Free Weights", "Bodyweight", "Gym Equipment"],
      // },
      {
        label: "Difficulties",
        key: "difficultiesLevel",
        type: "select",
        options: ["beginner", "intermediate", "advanced"],
      },
      // {
      //   label: "Workouts Categories",
      //   key: "workoutsCategories",
      //   type: "multi-select",
      //   options: [
      //     "Endurance",
      //     "Strength",
      //     "Balance",
      //     "Mobility",
      //     "Cardio",
      //     "HIIT",
      //     "Pilates",
      //     "Physiotherapy",
      //     "Other",
      //     "Yoga",
      //     "Tabata",
      //     "Sport Mastery",
      //   ],
      // },
    ],
  },
];

export const AllPreferenceInitialData = {
  weightGoal: "",
  conditionGoal: "",
  gainMuscle: "",
  dietaryPreferences: [],
  foodBudget: "",
  preparationTime: "",
  cookingFrequency: "",
  breakfastTastePreferences: [],
  lunchTastePreferences: [],
  dinnerTastePreferences: [],
  afternoonSnacks: [],
  eveningSnacks: [],
  yourAge: "",
  height: "",
  weight: "",
  waistCircumference: "",
  bodyFatPercentage: "",
  currentPhysicalConditionStatus: "",
  // gymMembership: "",
  dailyActivity: "",
  sleepHabits: "",
  stressLevel: "",
  selectableDays: [],
  dailyExerciseTimePreference: "",
  difficultiesLevel:"",
  // exerciseLocationPreference: [],
  // language: "",
  // preferredCoach: "",
  foodAllergies: [],
  healthConditions: [],
  targetWeight: "",
  timeline: "",
  durationType: "",
  multiCusine: [],
  goalBodyFat: "",
  goalWaistCircumference: "",
};
